<div class="add-vip-modal-container">
  <div class="modal-header">
    <span class="modal-title"><strong>{{ labels.createTitle }}</strong></span>
  </div>
  <div class="modal-divider"></div>
  <div class="body">
    <div class="table">
      <div class="table-title">
        <span>*</span>
        <span>{{labels.vipLevelName}}<span class="error">*</span></span>
        <span><span [innerHTML]="labels.inkRequired"></span><span class="error">*</span></span>
        <span>{{labels.discount}}(%)<span class="error">*</span></span>
      </div>
      <form [formGroup]="formVip">
        <div *ngFor="let vip of vipLevels" class="body-vip-modal">
          <span class="item">{{ getControlByVipType(vip.id, 'label').value }}</span>
          <app-input [control]="getControlByVipType(vip.id, 'name')"
                     [errorHint]="false"
                     [formGroup]="formVip">
          </app-input>
          <app-input [control]="getControlByVipType(vip.id, 'levelPoints')"
                     [errorHint]="false"
                     [formGroup]="formVip"
                     [type]="'number'">
          </app-input>
          <app-input [control]="getControlByVipType(vip.id, 'discount')"
                     [errorHint]="false"
                     [formGroup]="formVip"
                     [type]="'number'">
          </app-input>
        </div>
        <div class="generic-errors">
          <ul>
            <li class="error" *ngFor="let msg of getGenericErrors()">{{ msg }}</li>
          </ul>
        </div>
      </form>
    </div>
    <p class="text-warning">
      {{ labels.titleDesc }}
    </p>
  </div>
  <div class="modal-footer">
    <app-primary-button stroked (clickAction)="clickCancel()">{{ labels.cancel }}</app-primary-button>
    <app-primary-button (clickAction)="addBusinessLevel()" [disabled]="formVip.invalid || loading">{{ labels.saveChanges }}</app-primary-button>
  </div>
</div>
